// extracted by mini-css-extract-plugin
export default {"gameItem":"GameItem_gameItem__wwW+0","gameAvatar":"GameItem_gameAvatar__+efBY","gameName":"GameItem_gameName__erx29"};